<!-- =========================================================================================
    File Name: RegulationExcel.vue
    Description: Page to drop files & upload regulations excel
========================================================================================== -->
<template>
    <div class="dropfiles">
        <h2 class="font-light text-lg mb-5">ENVOYER LE FICHIER :</h2>
        <upload-files @uploadDone="listUploadedFiles()"></upload-files>        
    </div>
</template>
  
<script>
// @ is an alias to /src
import UploadFiles from '@/components/upload-files/UploadFiles'

import UploadFilesService from '@/services/UploadFilesService'

export default {
  name: 'Dropfiles',
  components: {
    UploadFiles
  },
  data () {
    return {
      files: [],
      intervalId: null
    }
  },
  mounted () {
    this.listUploadedFiles()
    // console.log('set inteval')
    this.intervalId = setInterval(() => {
      this.listUploadedFiles()
    }, 30000) //refresh page every 30 seconds
  },
  destroyed () {
    // console.log('inteval destroyed')
    clearInterval(this.intervalId)
  },
  methods: {
    listUploadedFiles () {
      this.$vs.loading()
      UploadFilesService.getFiles().then((res) => {
        this.files = res.data
      }).then(() => {
        this.$vs.loading.close()
      }).catch(() => {
        this.$vs.loading.close()
      })
    },
    forceFileDownload (response, title) {
      // console.log(title)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    deleteFile (id) {
      UploadFilesService
        .deleteFile(id).then(() => {
          this.$vs.notify({
            title: 'Fichier effacé',
            text: 'Votre fichier a bien été retiré de la liste des transferts',
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })
          this.listUploadedFiles()
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Lecture du fichier',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
input[type="file"] {
    position: absolute;
    top: -500px;
}

.deposit {
    background: url('~@/assets/images/icons/circle-bill-icon.svg') no-repeat center center;
    width: 230px;
    height: 230px;
    background-size: contain;
    padding: 104px 0 0;
}

div.file-listing {
    width: 200px;
}

span.remove-file {
    color: red;
    cursor: pointer;
    float: right;
}
</style>